<template>
    <main>
        <p>Admin Logout</p>
    </main>
</template>

<script>
    export default {
        name: "AdminLogout"
    }
</script>

<style lang="scss" scoped>

</style>
